import script from "./delete-company-link-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./delete-company-link-modal.vue?vue&type=script&setup=true&lang=ts"

import "./delete-company-link-modal.vue?vue&type=style&index=0&id=bd4c5094&lang=scss"

const __exports__ = script;

export default __exports__